import { Utils } from 'versafleet-core';

const { ReduxHelper } = Utils;

const initialState = {
  ourLocations: {},
  ourLocationIds: [],
};

function ourLocation(state = initialState, action) {
  switch (action.type) {
    case 'RECEIVE_OUR_LOCATIONS':
      return {
        ...state,
        ourLocationIds: action.ourLocations.map(location => location.id),
        ourLocations: ReduxHelper.mergeDataWithList(state.ourLocations, action.ourLocations),
      };
    default:
      return state;
  }
}

export default ourLocation;
